// extracted by mini-css-extract-plugin
export var container = "SeoTrailTabbed-module__container___yAHHD";
export var fader = "SeoTrailTabbed-module__fader___sef7E";
export var tabBar = "SeoTrailTabbed-module__tabBar___D0Wf4";
export var title = "SeoTrailTabbed-module__title___NB5Fc";